export async function submitFile(axios, file) {
  try {
    const formData = new FormData();
    formData.append('image', file);
    formData.append('media_type', 'ktm');

    const imgPostURL = 'ticket/upload/';
    const response = await axios.post(imgPostURL, formData);
    return response.data;
  } catch (e) {
    if (e.response) {
      const errorCode = e.response.data.code;
      if (errorCode === 'submit_failed' || errorCode === 'unknown_error') {
        throw new Error('Form submission fail');
      }
    }
    throw new Error(e?.response?.data?.message);
  }
}
